export const formatCurrency = (value) =>
  new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value || 0);

export const formatPercent = (value) => `${(value || 0).toFixed(1)}%`;

export const formatQty = (value) =>
  new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value || 0);
